import { api } from "./api";

export const createContest = (payload) =>
  api.post("/contests", payload).then((r) => r.data);

export const fetchContest = (code, asPid) =>
  api
    .get(`/contests/${code}`, { params: asPid ? { as_pid: asPid } : {} })
    .then((r) => r.data);

export const submitContestEntry = (code, participantId, picks) =>
  api
    .post(`/contests/${code}/entries`, {
      participant_id: participantId,
      picks,
    })
    .then((r) => r.data);

export const lockContest = (code, hostPid) =>
  api
    .post(`/contests/${code}/lock`, { host_participant_id: hostPid })
    .then((r) => r.data);

export const finalizeContest = (code, hostPid) =>
  api
    .post(`/contests/${code}/finalize`, { host_participant_id: hostPid })
    .then((r) => r.data);

export const reopenContestScoring = (code, hostPid) =>
  api
    .post(`/contests/${code}/reopen-scoring`, { host_participant_id: hostPid })
    .then((r) => r.data);

export const refreshContestScores = (code) =>
  api.post(`/contests/${code}/refresh-scores`).then((r) => r.data);

export const fetchPublicStandings = (code) =>
  api.get(`/contests/${code}/standings`).then((r) => r.data);

export const fetchPboTournaments = (code, hostPid) =>
  api
    .get("/pbo/tournaments", { params: { code, host_participant_id: hostPid } })
    .then((r) => r.data.tournaments);

export const fetchPboMatchPreview = (code, hostPid, tournamentId) =>
  api
    .get(`/contests/${code}/pbo/match-preview`, {
      params: { host_participant_id: hostPid, tournament_id: tournamentId },
    })
    .then((r) => r.data);

export const applyPboMatch = (code, hostPid, tournamentId, mapping, addUnmatched) =>
  api
    .post(`/contests/${code}/pbo/apply-match`, {
      host_participant_id: hostPid,
      tournament_id: tournamentId,
      mapping,
      add_unmatched: addUnmatched,
    })
    .then((r) => r.data);

export const dedupeGolfers = (code, hostPid) =>
  api.post(`/contests/${code}/golfers/dedupe`, { host_participant_id: hostPid }).then((r) => r.data);

export const setTeamName = (code, participantId, teamName) =>
  api
    .patch(`/contests/${code}/team-name`, { participant_id: participantId, team_name: teamName })
    .then((r) => r.data);

export const fetchGolferDetail = (code, golferId) =>
  api.get(`/contests/${code}/golfers/${golferId}/detail`).then((r) => r.data);

export const linkPboTournament = (code, hostPid, tournamentId, importRoster = true) =>
  api
    .post(`/contests/${code}/pbo/link`, {
      host_participant_id: hostPid,
      tournament_id: tournamentId,
      import_roster: importRoster,
    })
    .then((r) => r.data);

export const joinContest = (code, username) =>
  api.post(`/contests/${code}/join`, { username }).then((r) => r.data);

export const updateContestSettings = (code, hostPid, changes) =>
  api
    .patch(`/contests/${code}/settings`, { host_participant_id: hostPid, ...changes })
    .then((r) => r.data);

export const deleteContest = (code, hostPid) =>
  api
    .delete(`/contests/${code}`, { params: { host_participant_id: hostPid } })
    .then((r) => r.data);

export const addContestGolfer = (code, hostPid, name, salary) =>
  api
    .post(`/contests/${code}/golfers`, {
      host_participant_id: hostPid,
      name,
      salary,
    })
    .then((r) => r.data);

export const editContestGolfer = (code, hostPid, golferId, changes) =>
  api
    .patch(`/contests/${code}/golfers/${golferId}`, {
      host_participant_id: hostPid,
      ...changes,
    })
    .then((r) => r.data);

export const removeContestGolfer = (code, hostPid, golferId) =>
  api
    .delete(`/contests/${code}/golfers/${golferId}`, {
      params: { host_participant_id: hostPid },
    })
    .then((r) => r.data);

export const removeContestMember = (code, hostPid, memberId) =>
  api
    .delete(`/contests/${code}/members/${memberId}`, {
      params: { host_participant_id: hostPid },
    })
    .then((r) => r.data);

export const setContestMemberPaid = (code, hostPid, memberId, paid) =>
  api
    .patch(`/contests/${code}/members/${memberId}/paid`, {
      host_participant_id: hostPid,
      paid,
    })
    .then((r) => r.data);

export const setContestMemberEmail = (code, hostPid, memberId, email) =>
  api
    .patch(`/contests/${code}/members/${memberId}/email`, {
      host_participant_id: hostPid,
      email,
    })
    .then((r) => r.data);
